import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Switch, Redirect, Link } from 'react-router-dom';
import { createBrowserHistory } from "history";
import logo from './logo.svg';
import './App.css';
import { connect } from "react-redux";
import RouteWithSubRoutes from './router/RouteWithSubRoutes';
import LoginRoutes from './router/LoginRoutes';
import imgUrl from "./assets/images/imageUrl.js";
import Services from "./api/api";
import OffileDb from './config/pouchDB';
import { createStore } from 'redux';
import reducer from './redux/reducers/appReducer';
import NetworkDetector from './Hoc/NetworkDetector';
const store = createStore(reducer);

const customHistory = createBrowserHistory();

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      templateID: 1,
      redirectTo: ''
    };
  }

  componentDidMount() {
    //this.getApptempaleID()  
    this.checkIfCommunityConfigured();
  }

  componentWillMount() {
    customHistory.listen((location, action) => {
      this.getAppLogos();
    });
  }

  checkIfCommunityConfigured() {
    const myState = store.getState();
    if (myState.communityId) {
      this.setState({ redirectTo: '/Onboarding' })
    } else {
      this.setState({ redirectTo: '/CommunityList' })
    }
  }

  getApptempaleID() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getTemplatesByCommunityId(param).then((res) => {
        console.log(res)
        if (res.status == 200) {
          console.log(res.data.data.templateList)
          var tempobj = res.data.data.templateList.filter(obj => obj.isDefault == true)[0]['templateId']
          this.setState({ templateID: tempobj })
          //localStorage.setItem('templateID', tempobj)
          console.log(tempobj)
        }
      })
    }
  }

  getContentListByCommunityId() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.contentListByCommunityId(param).then((res) => {
        console.log(res)
        if (res.status == 200) {
          console.log(res.data.data.templateList)
          var tempobj = res.data.data.templateList.filter(obj => obj.isDefault == true)[0]['templateId']
          this.setState({ templateID: tempobj })
          console.log(tempobj)
        }
      })
    }
  }

  getAppLogos() {
    var that = this;
    OffileDb.getData('applogos').then(function (result) {
      if (result.status && result.status == 404) {
        if (navigator.onLine) {
          var param = {
            communityId: that.props.communityuid,
          };
          Services.getCommunityBrandingByCommunityId(param).then((res) => {
            if (res.status == 200) {
              OffileDb.setData('applogos', res.data.data)
            }
          })
        }
      }
    });
  }


  render() {
    var tempid = localStorage.getItem('templateID') || 1;
    return (
      <HashRouter history={customHistory}>
        {
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return (
                  <Redirect to={this.state.redirectTo} />
                )
              }}
            />
            {LoginRoutes.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        }
      </HashRouter>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    templateID: storeState.templateID,
    langId: storeState.langId,
  };
};
// export default connect(mapStateToProps, {})(NetworkDetector(App));
export default connect(mapStateToProps, {})(App);
//export default App;
